import type { Casino } from '../types/casino';

export const casinos: Casino[] = [
  {
    id: 'tulip-casino',
    name: 'Tulip Casino',
    initials: 'TC',
    color: '#D9530A',
    bonus: '100% tot NZ$500',
    bonusDetail: '+ 100 free spins op Gates of Olympus',
    rating: 4.8,
    payout: 'Binnen 12 uur',
    providers: [
      'Pragmatic Play',
      "Play'n GO",
      'NetEnt',
      'ELK Studios',
      'Hacksaw Gaming',
      'Relax Gaming',
      'Nolimit City',
      'Big Time Gaming',
      'BGaming',
      'Games Global',
      'Push Gaming',
    ],
    highlights: ['Nederlandstalige klantenservice', 'POLi & bankoverschrijving', 'Dagelijkse cashback'],
  },
  {
    id: 'harbour-play',
    name: 'Harbour Play',
    initials: 'HP',
    color: '#1F5C45',
    bonus: '200 free spins',
    bonusDetail: 'Verdeeld over 10 dagen, winsten zonder inzetvereiste',
    rating: 4.7,
    payout: 'Binnen 24 uur',
    providers: [
      'Pragmatic Play',
      "Play'n GO",
      'NetEnt',
      'Hacksaw Gaming',
      'Relax Gaming',
      'Big Time Gaming',
      'Games Global',
      'Push Gaming',
    ],
    highlights: ['Free spins zonder inzetvereiste', 'Sterke mobiele app', 'Apple Pay'],
  },
  {
    id: 'kea-spins',
    name: 'Kea Spins',
    initials: 'KS',
    color: '#2C5C8F',
    bonus: '50% tot NZ$1.000',
    bonusDetail: '+ wekelijkse reloadbonus van 25%',
    rating: 4.5,
    payout: 'Binnen 24 uur',
    providers: ['Pragmatic Play', "Play'n GO", 'ELK Studios', 'Hacksaw Gaming', 'Nolimit City', 'BGaming'],
    highlights: ['Hoge bonuslimiet', 'Toernooien met Pragmatic Play', 'Crypto & kaart'],
  },
  {
    id: 'southern-lights',
    name: 'Southern Lights Casino',
    initials: 'SL',
    color: '#5B3A8C',
    bonus: '10% cashback',
    bonusDetail: 'Elke week, zonder inzetvereiste',
    rating: 4.4,
    payout: 'Binnen 48 uur',
    providers: ['Pragmatic Play', 'NetEnt', 'Games Global', 'Relax Gaming', 'Big Time Gaming'],
    highlights: ['Cashback zonder voorwaarden', 'Jackpot-slots', 'Lage minimale storting'],
  },
];
